import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import About from './components/About';
import WhatWeDo from './components/WhatWeDo';
import CoreCapabilities from './components/CoreCapabilities';
import IndustriesServed from './components/IndustriesServed';
import Approach from './components/Approach';
import WhyGenieAiX from './components/WhyGenieAiX';
import CaseStudies from './components/CaseStudies';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="w-full px-20 py-5 flex items-center justify-between">
          <a href="/" className="cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/1638305ab25e301ab9a6bbb2f2a5b416.png" 
              alt="GenieAiX" 
              className="h-10 w-auto"
            />
          </a>
          <div className="flex items-center gap-10">
            <a href="#about" className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'}`}>About</a>
            <a href="#capabilities" className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'}`}>Capabilities</a>
            <a href="#industries" className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'}`}>Industries</a>
            <a href="#approach" className={`text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-white/80'}`}>Approach</a>
            <a 
              href="#contact" 
              className={`px-6 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${isScrolled ? 'bg-gray-900 text-white hover:bg-gray-800' : 'bg-white text-gray-900 hover:bg-gray-100'}`}
            >
              Get Started
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <TrustStrip />
      <About />
      <WhatWeDo />
      <CoreCapabilities />
      <IndustriesServed />
      <Approach />
      <WhyGenieAiX />
      <CaseStudies />
      <FinalCTA />
      <Footer />
    </div>
  );
}
